import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, Inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PriceBelowMinimumWarning } from '../price-below-minimum-warning/price-below-minimum-warning';

export interface EditPriceDialogData {
  nomeProdotto: string;
  prezzo: number;
  unitaMisura?: string;
  prezzoMinimo?: number;
}

export interface EditPriceDialogResult {
  price: number;
}

@Component({
  providers: [provideTranslocoScope('products')],
  selector: 'prd-edit-price-dialog',
  imports: [TranslocoPipe,
    MatDialogModule,
    MatButtonModule,
    PriceBelowMinimumWarning,
  ],
  templateUrl: './edit-price-dialog.html',
  styleUrl: './edit-price-dialog.scss',
})
export class EditPriceDialog {
  protected price = signal(0);

  constructor(
    private dialogRef: MatDialogRef<EditPriceDialog, EditPriceDialogResult>,
    @Inject(MAT_DIALOG_DATA) readonly data: EditPriceDialogData,
  ) {
    this.price.set(data.prezzo);
  }

  onPriceInput(value: string) {
    const parsed = parseFloat(value);
    this.price.set(Number.isNaN(parsed) || parsed < 0 ? this.data.prezzo : parsed);
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close({ price: this.price() });
  }
}
